import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ReportingList from "./ReportingList/ReportingList";
import DatasetList from "./DatasetList/DatasetList";
import VisitsMap from "./VisitsMap/VisitsMap";
import MessagePopUp from "../../components/Messages/MessagePopUp";
import { Tabs } from "antd";
import TabPane from "antd/es/tabs/TabPane";
import { isAuthorized } from "../../../services/authService";
import { RolesEnum } from "../../../services/rolesEnum"; // ✅ don’t forget this import

const validPages = {
  "?ReportingList": "ReportingList",
  "?DatasetList": "DatasetList",
  "?VisitsMap": "VisitsMap",
};

function Completed() {
  const [activeKey, setActiveKey] = useState("ReportingList");
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setActiveKey(validPages[location.search]);
  }, [location]);

  const handleTabChange = (key) => {
    navigate(`/project/completed?${key}`);
  };

  return (
    <div className="planning-page p-0">
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <Tabs
        activeKey={activeKey}
        onChange={handleTabChange}
        type="card"
        className="card-tabs mt-3"
        destroyInactiveTabPane={true}
      >
        <TabPane tab="Completed Visits" key="ReportingList">
          <div className="insideTab implementationPage">
            <ReportingList />
          </div>
        </TabPane>

        {isAuthorized([
          RolesEnum.ProjectManager,
          RolesEnum.SystemAdmin,
          RolesEnum.Guest,
          RolesEnum.FieldCoordinator,
        ]) && (
          <TabPane tab="Dataset List" key="DatasetList">
            <div className="insideTab implementationPage">
              <DatasetList />
            </div>
          </TabPane>
        )}

        <TabPane tab="Visit Map" key="VisitsMap">
          <div className="insideTab implementationPage">
            <VisitsMap />
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default Completed;
